/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Remove_ConfirmInputs */

const en_us2_coaching_remove_confirm = /** @type {(inputs: Coaching_Remove_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm: remove`)
};

const pt_br2_coaching_remove_confirm = /** @type {(inputs: Coaching_Remove_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar: remover`)
};

const pt_pt2_coaching_remove_confirm = /** @type {(inputs: Coaching_Remove_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar: remover`)
};

/** @type {(inputs: Coaching_Remove_ConfirmInputs) => LocalizedString} */
const es_419_coaching_remove_confirm = en_us2_coaching_remove_confirm;

/** @type {(inputs: Coaching_Remove_ConfirmInputs) => LocalizedString} */
const fr_fr2_coaching_remove_confirm = en_us2_coaching_remove_confirm;

/** @type {(inputs: Coaching_Remove_ConfirmInputs) => LocalizedString} */
const de_de2_coaching_remove_confirm = en_us2_coaching_remove_confirm;

/** @type {(inputs: Coaching_Remove_ConfirmInputs) => LocalizedString} */
const it_it2_coaching_remove_confirm = en_us2_coaching_remove_confirm;

/**
* | output |
* | --- |
* | "Confirm: remove" |
*
* @param {Coaching_Remove_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_remove_confirm = /** @type {((inputs?: Coaching_Remove_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Remove_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_remove_confirm(inputs)
	if (locale === "es-419") return es_419_coaching_remove_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_remove_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_remove_confirm(inputs)
	if (locale === "de-DE") return de_de2_coaching_remove_confirm(inputs)
	if (locale === "it-IT") return it_it2_coaching_remove_confirm(inputs)
	return en_us2_coaching_remove_confirm(inputs)
});
export { coaching_remove_confirm as "coaching.remove_confirm" }